// extracted by mini-css-extract-plugin
export default {"cls1":"WorkCard-cls1_rIb","cls2":"WorkCard-cls2_g7J WorkCard-cls1_rIb"};